import { gql } from "@apollo/client";

export const GET_INDICATIONS_NOTIFICATIONS = gql`
query GetIndicationsNotificationsRI ($idDelegacion: Int!) {
    indicationsNotificationsRI (idDelegacion: $idDelegacion) {
        asignacion
        validacion
        ingresoIndicacion
        cambioIndicacion
        confirmarEquipo
        cambioPrograma
    }
}`;